import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

export default function FornecedorList() {
  const [fornecedores, setFornecedores] = useState([]);
  const navigate = useNavigate();

  const fetchFornecedor = () => {
    api.get('/fornecedor')
      .then(res => setFornecedores(res.data))
      .catch(() => showError('Erro ao buscar fornecedores.'));
  };

  useEffect(() =>{
    fetchFornecedor();
  }, []);



  const handleDelete = async (id) => {


     const confirmed = await showConfirmation({
      title: 'Tem certeza?',
      text: `Você quer realmente remover esse registro?`,
      confirmText: 'Sim, deletar!',
      cancelText: 'Cancelar'
    });
    
    if (confirmed) {
      try {
        const response = await api.delete(`/fornecedor/${id}`);
        const message = response.data.message || 'Registro removido com sucesso.';

        showSuccess(message);

        fetchFornecedor();
      } catch (error) {
        let errorMessage = "";

        if (error.response)
          errorMessage = error.response.data.message;
        else if (error.request)
          errorMessage = "Sem resposta do servidor.";
        else
          errorMessage = "Erro desconhecido: " + error.message;

        showError(errorMessage || 'Erro inesperado.');
      }
    }

    
  };

  const columns = [
    { name: 'Nome', selector: row => row.nome, sortable: true },
    { name: 'Documento', selector: row => row.documento },
    { name: 'Telefone', selector: row => row.telefone || '-' },
    { name: 'Email', selector: row => row.email || '-' },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex align-items-center gap-1">
          <button className="btn btn-outline-success align-items-center btn-sm text-nowrap" onClick={() => navigate(`/fornecedor/${row.id}`)}>
            Editar
          </button>
          <button className="btn btn-outline-danger align-items-center btn-sm text-nowrap" onClick={() => handleDelete(row.id)}>
            Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: { whiteSpace: 'nowrap' },
      minWidth: '180px'
    }
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
      <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
         <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate('/menu')}
          >
            <i className="bi bi-arrow-left text-success"></i>
            <span className="text-success fw-semibold">Voltar</span>
          </button>
        <h5>Fornecedores</h5>
        <button className="btn btn-light text-success fw-bold d-flex align-items-center gap-1" onClick={() => navigate('/fornecedor/novo')}>Novo Fornecedor</button>
      </div>
      </div>
      <DataTable
        columns={columns}
        data={fornecedores}
        pagination
        highlightOnHover
        striped
        noDataComponent={<div className="text-muted">Nenhum fornecedor encontrado.</div>}
      />
    </div>
  );
}
